import GenericDialog from "../../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography";
import ActivationSelectSimContent from "./activation-select-sim-step/ActivationSelectSimContent";
import PropTypes from "prop-types";
import ActivationSummaryContent from "./activation-summary-step/ActivationSummaryContent";
import ActivationSummaryActions from "./activation-summary-step/ActivationSummaryActions";
import * as actions from "../../../../../../../../../store";
import ActivationRequestContent from "./activation-request-step/ActivationRequestContent";
import ActivationRequestActions from "./activation-request-step/ActivationRequestActions";
import {simsToIccIdAndMsisdnList} from "../../../../../../../../../shared/utils/utils";

const AttivaSimSecondariaDialog = (props) => {
    const dispatch = useDispatch()
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany)
    const userClaims = useSelector(state => state.authReducer.userClaims)
    const [step, setStep] = useState(0)
    const [selectedPrimaria, setSelectedPrimaria] = useState([]);
    const response = useSelector(state => state.ordiniConsipReducer.attivaSimSecondariaResponse.data);
    const loading = useSelector(state => state.ordiniConsipReducer.attivaSimSecondariaResponse.loading);

    useEffect(() => {
        if (!loading && response.status === 200) {
            setStep(2)
        }
    }, [loading, response.status])

    const onConfermaClick = () => {
        const note = selectedPrimaria[0].numeroDiTelefono;
        const reportProblemDto = {
            customerId: selectedCompany.integrationId,
            assistenzaId: selectedCompany.assistenzaId,
            screenCode: 'TM9_CONSIP_SECONDARIA',
            userId: userClaims.uid,
            changeInSelf: selectedCompany.changeInSelf,
            categoriaId: '',
            areaId: '',
            dettaglioId: '',
            message: '',
            addPlanOptions: [],
            removePlanOptions: [],
            referenteId: '',
            simList: simsToIccIdAndMsisdnList(props.selectedSims),
            note: note,
        }
        dispatch(actions.attivaSimSecondariaRequest(reportProblemDto))
    }

    const onClose = () => {
        dispatch(actions.clearAttivaSecondariaResponse());
        props.handleDialogClose();
    }

    const steps = {
        0: {
            content: <ActivationSelectSimContent
                selected={selectedPrimaria}
                setSelected={setSelectedPrimaria}
                selectedSims={props.selectedSims}
                handleSetStep={() => setStep(1)}/>,
            title: "Scegli la SIM primaria",
        },
        1: {
            content: <ActivationSummaryContent selectedPrimary={selectedPrimaria[0]}/>,
            actions: <ActivationSummaryActions
                loading={loading}
                onConfermaClick={() => onConfermaClick()}
                setPreviousStep={() => setStep(0)}/>,
            title: "Riepilogo della tua richiesta di attivazione",
        },
        2: {
            content: <ActivationRequestContent/>,
            actions: <ActivationRequestActions onChiudiClick={onClose}/>,
            title: "Riepilogo della tua richiesta di attivazione",
            dialogWidth: "xs",
            handleDialogClose: onClose
        }
    }

    return (
        <GenericDialog
            dialogWidth={steps[step].dialogWidth ?? "md"}
            handleDialogCloseButton={steps[step].handleDialogClose ?? props.handleDialogClose}
            handleDialogClose={steps[step].handleDialogClose ?? props.handleDialogClose}
            open={props.open}
            dialogContent={steps[step].content}
            dialogActions={steps[step].actions}
        >
            <Typography variant="h6">
                {steps[step].title}
            </Typography>
        </GenericDialog>
    )
}

AttivaSimSecondariaDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    selectedSims: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            numeroDiTelefono: PropTypes.string,
            seriale: PropTypes.string,
            dataOrdineDiConsegna: PropTypes.string,
            numeroOrdineDiConsegna: PropTypes.string
        })
    ).isRequired,
}

export default AttivaSimSecondariaDialog;